import React, { useLayoutEffect } from "react";
import { View, ViewStyle, StyleSheet } from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  useDerivedValue,
  withTiming,
  runOnJS,
} from "react-native-reanimated";

interface Props {
  children: React.ReactNode;
  open?: boolean;
  style?: ViewStyle[];
  duration?: number;
  isFaqList?: boolean;
}

const AnimatedDropdownWrapper = ({
  children,
  open = false,
  style = [{}],
  duration = 150,
  isFaqList = false,
}: Props) => {
  const height = useSharedValue(0);

  const animatedHeight = useDerivedValue(() => {
    console.log("Height: ", height.value);
    return withTiming(open ? height.value : 0, { duration });
  });

  const animatedStyle = useAnimatedStyle(() => {
    return {
      height: animatedHeight.value,
    };
  });

  return isFaqList ? (
    <View style={{ display: open ? "flex" : "none" }}>
      <Animated.View style={[styles.animatedView, animatedStyle]}>
        <View
          onLayout={(e) => {
            height.value = e.nativeEvent.layout.height;
          }}
        >
          <View style={style}>{children}</View>
        </View>
      </Animated.View>
    </View>
  ) : (
    <Animated.View style={[styles.animatedView, animatedStyle]}>
      <View
        onLayout={(e) => {
          height.value = e.nativeEvent.layout.height;
        }}
      >
        <View style={style}>{children}</View>
      </View>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  animatedView: {
    width: "100%",
    overflow: "hidden",
    // flex: 1,
  },
});

export default AnimatedDropdownWrapper;
